<div class="eiq-input-date__container">
  <span class="eiq-input-date__label">
    {{ label }}
    <span class="eiq-input-date__hint">{{ hint }}</span>
  </span>
  <mat-form-field appearance="outline" class="eiq-input-date__field" [subscriptSizing]="'dynamic'">
    <mat-date-range-input [formGroup]="dateRangeGrp" [rangePicker]="rangePicker" [comparisonStart]="min" [comparisonEnd]="max">
      <input matStartDate placeholder="Start date" formControlName="start" />
      <input matEndDate placeholder="End date" formControlName="end" />
    </mat-date-range-input>

    <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
    <mat-date-range-picker #rangePicker></mat-date-range-picker>
  </mat-form-field>
</div>
